module.exports = __webpack_public_path__ + "static/media/best-class@2x.6de89868.png";